"use client";
import { Link } from "@/components";
import { pathNames } from "@/lib/constants/pathNames.constants";
import SvgLogo from "./svg-logo";
type LogoProps = {
	readonly placement: "header" | "footer";
	readonly isSameTab?: boolean;
};

export default function Logo({ placement, isSameTab }: LogoProps) {
	const logo = {
		header: {
			title: "Analog Devices | ADI Developer",
			width: 137,
			height: 20,
			url: pathNames.home,
		},
		footer: {
			title: "Analog Devices",
			width: 85,
			height: 25,
			url: "https://analog.com",
		},
	};
	return (
		<div
			data-testid="logo"
			className={`${placement === "header" ? " pl-4" : ""}`}
		>
			<Link
				href={logo[placement].url}
				aria-label={logo[placement].title}
				data-testid="logo-link"
				isSameTab={isSameTab}
				className="logo flex flex-row"
			>
				<SvgLogo placement={placement} logoDetails={logo} />
			</Link>
		</div>
	);
}
